<template>
  <auth-shell>
    <div class="text-center">
      <img class="not-validated-illustration" src="/img/ship-icon.svg" />
      <h4 class="auth-title">Email Could Not Be Validated</h4>
      <p class="auth-body-text">
        If you believe you encountered this page in error, please let us
        know by emailing or contacting the in app support.
        <a href="mailto:info@ashoreapp.com">info@ashoreapp.com</a>
      </p>
    </div>
  </auth-shell>
</template>

<script>
import AuthShell from "../components/auth/auth-shell.vue";

export default {
  components: {
    AuthShell,
  },
};
</script>

<style scoped>
.not-validated-illustration {
  height: 100px;
  margin-bottom: 25px;
}
</style>
